import async from './async'
import {maskCpf, maskCpfCnpj, maskTel, maskMoney, maskCard, maskPlate, maskBirth, maskCnpj, maskHour, maskOneReal, maskCep} from './mask'
import onlyNumbers from './only-numbers'

export default {
  install(Vue, options) {
    Vue.directive('async', async);
    Vue.directive('mask-tel', maskTel);
    Vue.directive('mask-cpf-cnpj', maskCpfCnpj);
    Vue.directive('only-numbers', onlyNumbers);
    Vue.directive('mask-money', maskMoney);
    Vue.directive('mask-card', maskCard);
    Vue.directive('mask-plate', maskPlate);
    Vue.directive('mask-birth', maskBirth);
    Vue.directive('mask-cpf', maskCpf);
    Vue.directive('mask-cnpj', maskCnpj);
    Vue.directive('mask-hour', maskHour);
    Vue.directive('mask-one-real', maskOneReal);
    Vue.directive('mask-cep', maskCep);
  }
}



// WEBPACK FOOTER //
// ./src/directives/index.js